<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({
  agent: { type: Object, required: true },
  nativeRole: { type: Object, default: null },
});
const { t } = useI18n();
const own = computed(() => props.agent.permission_set_id != null);
const granular = computed(
  () => own.value || props.agent.custom_role_id != null
);
const label = computed(() => {
  if (own.value) {
    return props.agent.permission_set
      ? t('PERMISSION_SETS.ASSIGNMENT.OWN', {
          name: props.agent.permission_set.name,
        })
      : t('PERMISSION_SETS.ASSIGNMENT.CURRENT_OWN');
  }
  if (props.agent.custom_role_id != null) {
    return props.nativeRole
      ? t('PERMISSION_SETS.ASSIGNMENT.NATIVE', { name: props.nativeRole.name })
      : t('PERMISSION_SETS.ASSIGNMENT.CURRENT_NATIVE');
  }
  return props.agent.role === 'administrator'
    ? t('AGENT_MGMT.AGENT_TYPES.ADMINISTRATOR')
    : t('AGENT_MGMT.AGENT_TYPES.AGENT');
});
const permissions = computed(() =>
  own.value
    ? props.agent.permission_set?.permissions || []
    : props.nativeRole?.permissions || []
);
const permissionLabel = permission =>
  own.value
    ? t(`PERMISSION_SETS.CAPABILITY.${permission}`)
    : t(`CUSTOM_ROLE.PERMISSIONS.${permission.toUpperCase()}`);
</script>

<template>
  <span
    class="block w-fit text-body-main text-n-slate-11 relative"
    :class="{ 'hover:text-n-slate-12 group cursor-pointer': granular }"
  >
    {{ label }}
    <div
      v-if="granular"
      class="absolute ltr:left-0 rtl:right-0 z-10 hidden group-hover:block w-[300px] bg-n-alpha-3 backdrop-blur-[100px] rounded-xl outline outline-1 outline-n-container shadow-lg top-14 md:top-12"
    >
      <div class="flex flex-col gap-1 p-4">
        <span class="text-heading-3 text-n-slate-12">
          {{
            own
              ? $t('PERMISSION_SETS.CAPABILITIES')
              : $t('AGENT_MGMT.LIST.AVAILABLE_CUSTOM_ROLE')
          }}
        </span>
        <ul class="ltr:pl-4 rtl:pr-4 mb-0 list-disc">
          <li
            v-for="permission in permissions"
            :key="permission"
            class="text-body-main text-n-slate-11"
          >
            {{ permissionLabel(permission) }}
          </li>
        </ul>
      </div>
    </div>
  </span>
</template>
